import React from 'react';
import ServicePageLayout from '../../components/ServicePageLayout';
import { patentApplicationData } from '../../data/serviceData';

const PatentApplication = () => {
  return <ServicePageLayout data={patentApplicationData} />;
};

export default PatentApplication;
